import { Component, Input } from '@angular/core';

import { DATE_FORMAT } from '@app/app.constant';
import { AnswerTypeComponent } from '../answer-type.component';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'answer-datetime',
  templateUrl: './answer-datetime.component.html',
  standalone: false
})
export class AnswerDateTimeComponent extends AnswerTypeComponent {
  @Input() bsConfig: Partial<BsDatepickerConfig>;
  public datePlaceholder = DATE_FORMAT;

  onDateChange(value: Date) {
    if (value === this.formControlObj.value) {
      return;
    }
    this.formControlObj.setValue(value);
  }

}
